// @ts-nocheck
/* Starter Sync - RequisitionsHeader */

import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getRequisitionsDataView } from "@insite/client-framework/Store/Data/Requisitions/RequisitionsSelectors";
import addLinesToCart from "@insite/client-framework/Store/Pages/Requisitions/Handlers/AddLinesToCart";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import React, { useState } from "react";
import { connect, ResolveThunks } from "react-redux";

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    selectedRequisitionIds: state.pages.requisitions.selectedRequisitionIds,
    requisitionsDataView: getRequisitionsDataView(state, state.pages.requisitions.getRequisitionsParameter),
    showAddToCartConfirmationDialog: getSettingsCollection(state).productSettings.showAddToCartConfirmationDialog,
});

const mapDispatchToProps = {
    addLinesToCart,
};

export interface RequisitionsActionsStyles {
    approveButton?: ButtonPresentationProps;
    approveLink?: LinkPresentationProps;
}

export const requisitionsActionsStyles: RequisitionsActionsStyles = {};

const styles = requisitionsActionsStyles;

const RequisitionsActions = ({
    fields: widgetFields,
    selectedRequisitionIds,
    requisitionsDataView,
    showAddToCartConfirmationDialog,
    addLinesToCart,
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const trackAddToCart = ga.use.trackAddToCart();
    const toasterContext = useToaster();
    const requisitions = requisitionsDataView.value;

    const approveClickHandler = () => {
        setIsLoading(true);
        const cartLines: CartLineModel[] = [];
        selectedRequisitionIds.forEach((requisitionId: string) => {
            const requisition = requisitions?.find(o => o.id === requisitionId);
            requisition && cartLines.push(requisition);
        });

        if (cartLines.length === 0) {
            return;
        }

        addLinesToCart({
            apiParameter: {
                cartId: API_URL_CURRENT_FRAGMENT,
                cartLineCollection: { cartLines } as CartLineCollectionModel,
            },
            onSuccess: () => {
                if (showAddToCartConfirmationDialog) {
                    toasterContext.addToast({
                        body: siteMessage("Cart_AllProductsAddedToCart"),
                        messageType: "success",
                    });
                }
                trackAddToCart({ items: cartLines });
                setIsLoading(false);
            },
            onComplete(resultProps) {
                if (resultProps.apiResult) {
                    // "this" is targeting the object being created, not the parent SFC
                    this.onSuccess?.();
                }
            },
        });
    };

    const hasSelected = selectedRequisitionIds.some(
        (requisitionId: string) => !!requisitions?.find(o => o.id === requisitionId),
    );
    return (
        <OrderActionSet
            fields={widgetFields}
            actions={[
                {
                    key: "approve",
                    label: translate("Approve Selected"),
                    onClick: approveClickHandler,
                    buttonStyles: styles.approveButton,
                    linkStyles: styles.approveLink,
                    isDisabled: !hasSelected,
                    isLoading,
                    isSticky: true,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RequisitionsActions),
    definition: {
        allowedContexts: ["RequisitionsPage"],
        group: "Requisitions",
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([]),
    },
};

export default widgetModule;
